module.exports = __webpack_public_path__ + "img/speak.5509113f.png";